import * as React from 'react'
import { classNames } from '@common/utils/helpers'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

interface CardFooterProps extends React.HTMLAttributes<HTMLElement> {
  className?: string | undefined
}

type CardFooter = React.FC<React.PropsWithChildren<CardFooterProps>>

const CardFooterWrapper = styled.div`
  &.pq-card-footer {
    box-shadow: 0 -2px 24px 0 rgba(223, 231, 255, 0.2);
    background-color: #ffffff;
    border-radius: 16px;
    display: flex;
    width: 100%;
    padding: 0;
    margin: 0 auto;
  }
`

/**
 * @deprecated use {@palqee/ui/card}
 */
const CardFooter: CardFooter = (props) => {
  const { children, className, ...rest } = props
  const classes = classNames('pq-card-footer', className || '')
  return (
    <CardFooterWrapper className={classes} {...rest}>
      <div
        css={css`
          width: 85%;
          margin: 0 auto;
        `}
      >
        {children}
      </div>
    </CardFooterWrapper>
  )
}

export default CardFooter
